export default __webpack_public_path__ + "static/media/logoReplacement.aceb1b2e.svg";